export enum GlobalSearchField {
    InvoiceNumber = 'invoiceNumber',
    CheckNumber = 'checkNumber'
}
